import { post,get,postJson } from './axios'

const RESOURCE_BASE_PATH = '/members-api/common'

// 获取商家的信息
export const getChannelSellerInfo = p => post(`${RESOURCE_BASE_PATH}/getChannelSellerInfo`, p);

